import './css/index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import Component from './component';

export default class {

    static name = 'data-periodic-release-archive-filter';

    constructor( config ) {

        this.config = config;
        this.wrapper = config.element;

        this.root = createRoot( this.wrapper );

    }

    ready() {

        this.root.render(
            <Component
                config={ this.config }
            />,
        );

    }

}
